<template>
  <div  :style='{width: panelWidth}' >
    <el-table
      class='riskTable'
      :data="data"
      :cell-class-name = "() => 'lu-click'"
      :height="panelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @row-dblclick='row => getDetail(row.instrumentName)'
    >
      <el-table-column :label="$t('Instrument')" sortable prop='instrumentName'  align="left" />
      <el-table-column :label="$t('SE LPs')" sortable prop='exposure1' :sort-method='(a,b) => sortFloat(a,b,"exposure1")' align="left">
        <template slot-scope="scope">
          <el-tooltip :effect='styleTooltip'>
            <div slot="content">
              <lu-hbox class='tooltip'>
                <lu-item lu-flex class='itemTitle'>{{ $t('VWAP') }} :</lu-item>
                <lu-item class='itemValue'>{{ scope.row.vwap1 | formatRate(6) }}</lu-item>
              </lu-hbox>
            </div>
            <div style='text-align: right' :class='scope.row.exposure1 >= 0  ? "positive" : "negative"'>{{ scope.row.exposure1 | formatAmount(true) }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column :label="$t('SE STP')" sortable prop='exposure2' :sort-method='(a,b) => sortFloat(a,b,"exposure2")' align="left">
        <template slot-scope="scope">
          <el-tooltip :effect='styleTooltip'>
            <div slot="content">
              <lu-hbox class='tooltip'>
                <lu-item lu-flex class='itemTitle'>{{ $t('VWAP') }} :</lu-item>
                <lu-item class='itemValue'>{{ scope.row.vwap2 | formatRate(6) }}</lu-item>
              </lu-hbox>
            </div>
            <div style='text-align: right' :class='scope.row.exposure2 >= 0  ? "positive" : "negative"'>{{ scope.row.exposure2 | formatAmount(true) }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column :label="$t('SE Discrepancy')" sortable prop='delta1' :sort-method='(a,b) => sortFloat(a,b,"delta1")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.delta1 == 0  ? "positive" : "negative"'>{{ scope.row.delta1 | formatAmount(true) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('CY LPs')" sortable prop='exposure3' :sort-method='(a,b) => sortFloat(a,b,"exposure3")' align="left">
        <template slot-scope="scope">
          <el-tooltip :effect='styleTooltip'>
            <div slot="content">
              <lu-hbox class='tooltip'>
                <lu-item lu-flex class='itemTitle'>{{ $t('VWAP') }} :</lu-item>
                <lu-item class='itemValue'>{{ scope.row.vwap3 | formatRate(6) }}</lu-item>
              </lu-hbox>
            </div>
            <div style='text-align: right' :class='scope.row.exposure3 >= 0  ? "positive" : "negative"'>{{ scope.row.exposure3 | formatAmount(true) }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column :label="$t('CY STP')" sortable prop='exposure4' :sort-method='(a,b) => sortFloat(a,b,"exposure4")' align="left">
        <template slot-scope="scope">
          <el-tooltip :effect='styleTooltip'>
            <div slot="content">
              <lu-hbox class='tooltip'>
                <lu-item lu-flex class='itemTitle'>{{ $t('VWAP') }} :</lu-item>
                <lu-item class='itemValue'>{{ scope.row.vwap4 | formatRate(6) }}</lu-item>
              </lu-hbox>
            </div>
            <div style='text-align: right' :class='scope.row.exposure4 >= 0  ? "positive" : "negative"'>{{ scope.row.exposure4 | formatAmount(true) }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column :label="$t('CY Discrepancy')" sortable prop='delta2' :sort-method='(a,b) => sortFloat(a,b,"delta2")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.delta2 == 0  ? "positive" : "negative"'>{{ scope.row.delta2 | formatAmount(true) }}</div>
        </template>
      </el-table-column>

      <!-- <el-table-column :label="$t('Omnibus')" sortable prop='exposure' :sort-method='(a,b) => sortFloat(a,b,"exposure")' align="left">
        <template slot-scope="scope">
          <el-tooltip :effect='styleTooltip'>
            <div slot="content">
              <lu-hbox class='tooltip'>
                <lu-item lu-flex class='itemTitle'>{{ $t('VWAP') }} :</lu-item>
                <lu-item class='itemValue'>{{ scope.row.vwap | formatRate(6) }}</lu-item>
              </lu-hbox>
            </div>
            <div style='text-align: right' :class='scope.row.exposure >= 0  ? "positive" : "negative"'>{{ scope.row.exposure | formatAmount }}</div>
          </el-tooltip>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :label="$t('STP Totals')" sortable prop='posExposure' :sort-method='(a,b) => sortFloat(a,b,"posExposure")' align="center">
        <template slot-scope="scope">
          <el-tooltip :effect='styleTooltip'>
            <div slot="content">
              <lu-hbox class='tooltip'>
                <lu-item lu-flex class='itemTitle'>{{ $t('VWAP') }} :</lu-item>
                <lu-item class='itemValue'>{{ scope.row.posVwap | formatRate(6) }}</lu-item>
              </lu-hbox>
            </div>
            <div style='text-align: right' :class='scope.row.posExposure >= 0  ? "positive" : "negative"'>{{ scope.row.posExposure | formatAmount }}</div>
          </el-tooltip>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :label="$t('Discrepancy')" sortable prop='delta' :sort-method='(a,b) => sortFloat(a,b,"delta")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.delta >= 0  ? "positive" : "negative"'>{{ scope.row.delta | formatAmount(true) }}</div>
        </template>
      </el-table-column> -->
    </el-table>

    <el-drawer :append-to-body="true" ref="reconciliationConfigDrawer" :title="$t('Reconciliation Config')" :visible.sync="showDialog" direction="rtl" size="80%" destroy-on-close :before-close="handleClose" :modal="false">
      <div class="handle-button-close" @click='closeDialog'>
        <i class="el-icon-close" />
      </div>
      <reconciliation-config />
    </el-drawer>

  </div>
</template>

<script>
import { LuHbox, LuItem } from 'lusis-ui'
import utils from '@/utils/formatNumber'
import { mapGetters, mapState } from 'vuex'
import monitoringMixin from './mixins'
import ReconciliationConfig from './components/reconciliationConfig'

export default {
  name: 'Reconciliation',
  props: [ 'data', 'label', 'panel' ],
  mixins: [ monitoringMixin ],
  components: { LuHbox, LuItem, ReconciliationConfig },
  filters: {
    formatAmount: function (value, emptyIfZero) {
      if (!value) {
        return utils.formatAmount(0, 2, 3, emptyIfZero)
      }
      return utils.formatAmount(value || 0, 2, 3)
    },
    formatRate: function (value, prec) {
      value = value || 0
      let idx = ('' + value).indexOf('.')
      if (idx !== -1) prec = value.length - idx - 1
      return utils.formatNumber(value, prec)
    }
  },
  computed: {
    ...mapGetters([ 'theme' ]),
    ...mapState({ panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    }
  },
  methods: {
    getDetail: function (label) {
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': 'symbol', 'paramValue': label}
      ]
      this.$emit('getDetail', {title: this.panel.options.title, type: 'symbol', value: label, params: params, show: true})
    },
    onSettings () {
      this.showDialog = !this.showDialog
    },
    handleClose(done) {
      this.showDialog = false
      setTimeout(() => {
        done();
        // animation takes time
        setTimeout(() => {
        }, 400);
      }, 600);
    },
    closeDialog () {
      if (this.$refs.reconciliationConfigDrawer)
        this.$refs.reconciliationConfigDrawer.closeDrawer()
    }
  },
  data: function () {
    return {
      lots: false,
      showDialog: false
    }
  }
}
</script>

<style lang='scss' scoped>
.inst-container {
  .rowData {
    justify-content: center;
    vertical-align: baseline;
    height: 25px;
    margin: 5px 0;
  }
}
</style>